export default __webpack_public_path__ + "static/media/body-section-shoulders.7ea5c61d.png";